import React from 'react';
import { formatterCompact } from '../styles/GlobalStyles';
import { Typewriter } from './';
import { renderHTML } from '../functions';

function Scenario(props) {
    const label = props.label;
    const option = props.scenario;
    // const expanded = props.expanded;
    // const setExpanded = props.setExpanded;
    const typeOutText = props.typeOutText;
    const textFinished = props.textFinished;
    const darkMode = props.darkMode;
    
    return (
        <div className={"chat-action-required-scenario-element " + (darkMode === true ? "bg-colour-black" : "bg-colour-white")}>
            <div className="chat-action-required-scenario-title-container">
                <span className={"body-bold " + (darkMode === true ? " colour-white" : "colour-primary")}>
                    {label}
                </span>
                <span className={"body-regular " + (darkMode === true ? " colour-white" : "colour-primary")}>
                    {formatterCompact.format(option.arv)}
                </span>
            </div>
            {/* {
                option.assumptions.map((item, index) =>
                    <span 
                        className={"body-regular " + (darkMode === true ? " colour-white" : "colour-primary")}
                        key={index}
                    >
                        {item}
                    </span>
                )
            } */}
            <div className="chat-action-required-details-container">
                {
                    typeOutText === true ?
                    <Typewriter
                        text={option.description}
                        delay={10}
                        commaDelay={0}
                        fullStopDelay={0} 
                        play={true}
                        className={"body-regular " + (darkMode === true ? " colour-white" : "colour-primary") + " block-text white-space-pre-wrap typewriter-text-gap"}
                        isHTML={true}
                        onComplete={textFinished}
                    />
                    :
                    <div
                        className={"body-regular " + (darkMode === true ? " colour-white" : "colour-primary") + " typewriter-text-gap"}
                        dangerouslySetInnerHTML={{ __html: renderHTML(option.description) }}
                    />
                }
            </div>
            {/* <div className="chat-action-required-details-container">
                <Button
                    buttonType={darkMode === true ? "secondary-button-dark" : "secondary-button"}
                    size="x-small"
                    text={expanded === true ? "Hide details" : "Details"}
                    cta={() => setExpanded(!expanded)}
                    disabled={false}
                    leftIcon={null}
                    leftIconClass=""
                    rightIcon={null}
                    rightIconClass=""
                    alt=""
                    standardIcon={false}
                    badge={false}
                    badgeVal={null}
                    badgeBG={null}
                    buttonRef={null}
                    spinner={false}
                />
            </div> */}
        </div>
    )
}

export default Scenario;
